import React from 'react';
import PropTypes from 'prop-types';
import {DialogTitle, IconButton} from "@material-ui/core";
import cn from 'classnames';
import BaseComponent from '../BaseComponent';

const noop = () => 0;

export const DialogTitleContainer = ({style, className, classes, ...rest}) =>
    (<BaseComponent as={DialogTitle}
                    className={cn(classes.titleContainer, className)}
                    style={style}
                    disableTypography
                    {...rest}/>);

/* ---------------------- TitleButton Component ---------------------- */
export const TitleButton = ({className, onClick, location, ...rest}) => (
    <IconButton onClick={onClick} className={cn('titleButton', location, className)} {...rest}/>
);

TitleButton.propTypes = {
    location: PropTypes.oneOf(['left', 'right']),
    onClick: PropTypes.func,
};

TitleButton.defaultProps = {
    location: 'left',
    onClick: noop,
};

/* ---------------------- Title Component ---------------------- */
export const Title = ({style, className, ...rest}) => (
    <BaseComponent as="h6" style={style} className={cn('title', className)} {...rest}/>);
